import React from "react";
import { BrowserRouter as Router, Switch } from "react-router-dom";
import { Refreshable } from "react-router-refreshable";
import { ToastContainer } from "react-toastify";
import FaqPage from "../faq/FaqPage";
import FindLocationPage from "../findLocation/FindLocationPage";
import NavBarHomePage from "../navBarHomePage/NavBarHomePage";
import Navbar from "../navBarMenu/Navbar";
import NewLocationPage from "../newLocation/NewLocationPage";
import OrderReleaseDetailsPage from "../orderRelease/OrderReleaseDetailsPage";
import OrderReleasePage from "../orderRelease/OrderReleasePage";
import PurchaseOrderReleasePage from "../purchaseOrderRelease/PurchaseOrderReleasePage";
import InvoicePaymentStatusPage from "../ScheduledPayment/InvoicePaymentStatusPage";
import SearchOrderReleasePage from "../searchOrderRelease/SearchOrderReleasePage";

import SearchPurchaseOrderForOrderReleasePage from "../searchPurchaseOrderForOrderRelease/SearchPurchaseOrderForOrderReleasePage";
import ProtectedRoute from "./auth/ProtectedRoute";
import TourPage from "./TourPage";

const HomePage: React.FC = () => {
  return (
    <>
      <div className="pageContent-style">
        <Router>
          <Navbar />
          <Refreshable>
            <Switch>
              <ProtectedRoute path="/home" component={NavBarHomePage} />
              <ProtectedRoute path="/newLocation" component={NewLocationPage} />
              <ProtectedRoute
                path="/findLocation"
                component={FindLocationPage}
              />
              <ProtectedRoute
                path="/searchOrderRelease"
                component={SearchOrderReleasePage}
              />
              <ProtectedRoute
                path="/searchPurchaseOrderRelease"
                component={SearchPurchaseOrderForOrderReleasePage}
              />
              <ProtectedRoute
                path="/orderRelease"
                component={OrderReleasePage}
              />
              <ProtectedRoute
                path="/purchaseOrderRelease"
                component={PurchaseOrderReleasePage}
              />
              <ProtectedRoute
                path="/OrderReleaseDetails"
                component={OrderReleaseDetailsPage}
              />
              <ProtectedRoute
                path="/invoicePaymentStatus"
                component={InvoicePaymentStatusPage}
              />
              <ProtectedRoute path="/faq" component={FaqPage} />
              <ProtectedRoute path="/tour" component={TourPage} />
            </Switch>
          </Refreshable>
          <ToastContainer containerId="toast-container" autoClose={5000} />
        </Router>
      </div>
    </>
  );
};

export default HomePage;
